import { Button, ThemeIcon, Stack, Group, Text, Badge, Indicator } from "@mantine/core";
import { IconClipboardCheck, IconClipboardList, IconClipboardPlus } from "@tabler/icons-react";
import moment from "moment";
import cx from "clsx";

import { ListWorkOrderDto, WorkOrderStatus } from "../../models/workorder.models";
import { getWorkOrderStatusColor, getWorkOrderStatusDescription } from "../../functions/workorder.functions";
import classes from './WorkOrderList.module.css';

interface WorkOrderListItemProps {
	workOrder: ListWorkOrderDto;
	selected?: boolean;
	onSelect: (workOrder: ListWorkOrderDto) => void;
	showLocation?: boolean;
	showCategories?: boolean;
}

export const WorkOrderListItem = ({ workOrder, selected, onSelect, showLocation, showCategories }: WorkOrderListItemProps) => {
	const isRequest = workOrder.Status === WorkOrderStatus.Requested;
	const isCompleted = workOrder.Status === WorkOrderStatus.Completed;
	const isDeleted = workOrder.Deleted != null;
	const isOverdue = workOrder.DueDate != null ? moment.utc(workOrder.DueDate).isBefore(moment.utc()) && !isCompleted : false;

	const handleWorkOrderSelect = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		onSelect(workOrder);
	};

	return <Button
		component="a"
		href={`/workorders/${workOrder.WorkOrderId}`}
		key={workOrder.WorkOrderId}
		onClick={handleWorkOrderSelect}
		className={cx(classes['workorder-list-item'], { [classes['selected-item']]: selected })}
		leftSection={<ThemeIcon radius="xl"
			// color={isRequest ? "teal" : ""}
			size="xl"
			style={{ border: `1px solid var(--mantine-color-default-border)` }}
			variant="light"
		>
			<Indicator offset={-6} size={16} zIndex={0} withBorder disabled={workOrder.Read} position="top-end">
				{isRequest ? <IconClipboardPlus size={24} /> : isCompleted ? <IconClipboardCheck size={24} /> : <IconClipboardList size={24} />}
			</Indicator>
		</ThemeIcon>}
	>
		<Stack w={"100%"} gap={4}>
			<Group justify="space-between" align="flex-start" w="100%" wrap="nowrap">
				<Stack align="flex-start" gap={0}>
					<Text c="var(--mantine-color-text)" fw={workOrder.Read ? "400" : "600"} style={{ textWrap: 'wrap', textAlign: 'left' }} lineClamp={1}>{workOrder.Title}</Text>
					<Text fz="sm" c="dimmed" style={{ textWrap: 'wrap', textAlign: 'left' }} lineClamp={1}>Requested by {workOrder.CreatedBy.Name}</Text>
				</Stack>
				<Stack gap={0} align="flex-end">
					{showLocation && <Text fz="sm" c="dimmed" visibleFrom="xs">{workOrder.Location.Title}</Text>}
					{showCategories && workOrder.Categories.length > 0 ? (
						<Text fz="sm" c="dimmed" style={{ whiteSpace: 'wrap', textAlign: 'end' }}>
							{workOrder.Categories.map(cat => cat.Title).join(', ')}
						</Text>
					) : null}
					{!isRequest &&
					<Text c="var(--mantine-color-text)">#{workOrder.WorkOrderNumber}</Text>
					}
				</Stack>
			</Group>
			{showLocation && <Text fz="sm" c="dimmed" hiddenFrom="xs" style={{ textAlign: 'left' }}>{workOrder.Location.Title}</Text>}
			<Group justify="space-between" w="100%">
				<Group gap={4}>
					{!isDeleted &&
					<Badge variant="light" color={getWorkOrderStatusColor(workOrder.Status)} size="md" radius="sm">
						{getWorkOrderStatusDescription(workOrder.Status)}
					</Badge>
					}
					{isDeleted &&
					<Badge variant="light" color="red" size="md" radius="sm">
						Deleted
					</Badge>
					}
					{isOverdue && !isDeleted &&
					<Badge variant="light" color="red" size="md" radius="sm">
						Overdue
					</Badge>
					}
					</Group>
				{!isRequest &&
				<Badge variant="dot" color={workOrder.Priority?.Colour} size="md" radius="sm">
					{workOrder.Priority?.ShortTitle}
				</Badge>
				}
			</Group>
		</Stack>
	</Button>
}